import { _, React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import { FormControlLabel, Switch } from '@material-ui/core'

const styles = (theme: CentricTheme) => ({
  icon:       {
    borderRadius: 10
  },
  switchBase: {
    color: 'var(--background-grey-4)'
  },
  checked:    {
    color: 'var(--tertiary-green)'
  },
  bar:        {
    backgroundColor: 'var(--background-grey-6)'
  },
  barChecked: {
    backgroundColor: 'var(--tertiary-green) !important'
  },
  label:      {
    fontSize:   12,
    fontWeight: 'normal',
    color:      'var(--typography-caption-color)',
    marginLeft: 2
  },

  black:  {
    color: 'var(--primary) !important',
  },
  purple: {
    color: 'var(--tertiary-purple) !important',
  },
  green:  {
    color: 'var(--tertiary-green) !important',
  },
  red:    {
    color: 'var(--tertiary-red) !important',
  },
  pink:   {
    color: 'var(--tertiary-pink) !important',
  },
  yellow: {
    color: 'var(--tertiary-yellow) !important',
  }
})

interface MyProps extends StyledProps {
  /** String for the name of the field */
  name: string,
  /** String for the value of the field */
  value?: string,
  /** Boolean indicating whether the switch is active or not */
  checked?: boolean
  /** Function to handle the onChange event */
  onChange?: (e) => void
  /** String for the field's label when selected/checked */
  activeLabel?: string,
  /** String for the field's label when deselected/unchecked */
  inactiveLabel?: string,
  /** Boolean indicating whether the button should render as disabled */
  disabled?: boolean
  color?: any
}

@(withStyles as any)(styles)
export class SwitchInput extends React.Component<MyProps> {
  static defaultProps = {
    name:          '',
    checked:       false,
    onChange:      () => {},
    activeLabel:   '',
    inactiveLabel: '',
    disabled:      false,
    color:         'green'
  }

  render() {

    const {name, value, checked, onChange, activeLabel, inactiveLabel, disabled, classes, color, ...other} = this.props

    return (
      <FormControlLabel
        classes={{label: classes.label}}
        control={
          <Switch
            name={name}
            value={value}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            classes={{
              // icon:        classes.icon,
              switchBase:  classes.switchBase,
              checked:     classNames(classes.checked, classes[color]),
              //bar:         classNames(classes[checked ? 'barChecked' : 'bar'], classes[color]),
              //iconChecked: classNames(classes.checked, classes[color])
            }}
            {...other}
          />
        }
        label={checked ? activeLabel : inactiveLabel}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/SwitchInput.tsx